import React, { useMemo, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';


import SearchList from './SearchList';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useAllProductsPricesSSR } from '../../hooks/useAllProductsPricesSSR';
import { useAllProducts } from '../../hooks/useAllProducts';
import { Icon } from '../primitives';

export default function SearchBar() {
    const [searchString, setSearchString] = useState('');
    const [localSearchString, setLocalSearchString] = useState(searchString);

    const searchIcon =
        'M16.692,0c-6.4,0-11.6,4.5-11.6,10.025A9.2,9.2,0,0,0,7.748,16.4L0,23.1l1.563,1.35,7.748-6.7a12.7,12.7,0,0,0,7.382,2.3c6.4,0,11.6-4.5,11.6-10.025S23.09,0,16.692,0Zm0,18.141c-5.179,0-9.392-3.641-9.392-8.116S11.514,1.91,16.692,1.91s9.392,3.641,9.392,8.116S21.871,18.141,16.692,18.141Z';
    const { navigateTranslated, currentLocale } = usePageLocalization();
    const queryResult: any = useAllProductsPricesSSR();
    const [allProducts] = useAllProducts();
    const { t } = useTranslation('mainLayout');

    const allMagentoProducts =
        queryResult && currentLocale === 'en_US'
            ? queryResult[`magento_century_en_us`]?.products?.items
            : queryResult?.[`magento_century_fr_ca`]?.products?.items;
    const [isDropdowOpen, setDropdownOpen] = useState(false);
    const searchTermsDelay = useMemo(
        () => debounce(setSearchString, 1000),
        [setSearchString]
    );
    return (
        <div className='search-bar-container'>
            <div className='mainSearchBar'>
                <input
                    type='text'
                    className='input'
                    value={localSearchString}
                    onChange={(event) => {
                        setLocalSearchString(event.target.value);
                        searchTermsDelay(event.target.value);
                        if (!isDropdowOpen && searchString.length >= 2)
                            setDropdownOpen(true);
                    }}
                    onClick={() => {
                        if (!isDropdowOpen && searchString.length >= 2) {
                            setDropdownOpen(true);
                        }
                    }}
                    onKeyDown={(keyboardEvent) =>
                        keyboardEvent.key === 'Enter' &&
                        navigateTranslated(`/s/?q=${localSearchString}`)
                    }
                    onBlur={() => {
                        setTimeout(() => {
                            if (isDropdowOpen) {
                                setDropdownOpen(false);
                            }
                        }, 1000);
                    }}
                    placeholder={t('search-placeholder') || ''}
                />

                <Icon
                    d={searchIcon}
                    size='24'
                    viewBox='0 0 28.294 24.449'
                    transform='translate(0 0)'
                    onClick={() =>
                        navigateTranslated(`/s/?q=${localSearchString}`)
                    }
                />
                <SearchList
                    searchString={searchString}
                    allMagentoProducts={allMagentoProducts}
                    allProducts={allProducts.nodes}
                    isSearchListOpen={isDropdowOpen}
                    setSearchListOpen={setDropdownOpen}
                    t={t}
                />
            </div>
        </div>
    );
}
